import { render, staticRenderFns } from "./by-email.vue?vue&type=template&id=2e17d82a"
import script from "./by-email.vue?vue&type=script&lang=js"
export * from "./by-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/registration/by-email.vue
// module id = UGz6
// module chunks = 0